import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import "flatpickr/dist/themes/material_blue.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";
import InputMask from "react-input-mask";

import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import Select from "react-select";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import TableComponent from "components/Common/TableComponent";
import { use } from "i18next";
//import { C } from "@fullcalendar/core/internal-common";
import Config from "config";
function EditReservation() {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  let { id } = useParams();
  const navigate = useNavigate();
  const tableaustyles = {
    background: "#555B21",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
  };
  const colStyle = {
    width: "20em", // Largeur fixe pour la première colonne
    whiteSpace: "wrap", // Empêche le texte de revenir à la ligne
    display: "inline-block", // Permet de conserver le texte sur une seule ligne
    color: "#7f7f7f",
    verticalAlign: "middle", // Alignement vertical au centre pour le texte
    display: "flex", // Utilisation de flexbox pour aligner les éléments horizontalement
    alignItems: "center", // Centrage vertical du texte et de l'input
  };
  const layout = localStorage.getItem("layoutMode");

  const styles = (hasError) => ({
    container: (provided) => ({
      ...provided,
      overflow: "visible",
      fontSize: "0.7109375rem",
    }),
    menu: (provided) => ({
      ...provided,
      textAlign: "left",
      overflow: "visible",
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Couleur de fond selon le mode
      color: layout === "dark" ? "#fff" : "#000", // Couleur du texte selon le mode
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#555B21"
        : layout === "dark"
        ? "#444"
        : "transparent", // Ajustement du background selon le mode
      color: state.isSelected ? "white" : layout === "dark" ? "#fff" : "black", // Ajustement de la couleur selon le mode
      textAlign: "left",
      fontWeight: "normal",
      paddingLeft: 40,
      paddingTop: 10,
    }),
    groupHeading: (provided) => ({
      ...provided,
      fontWeight: "bold",
      fontSize: "15px",
      color: layout === "dark" ? "white" : "black", // Couleur selon le mode
      textAlign: "left",
    }),

    control: (provided, state) => ({
      ...provided,
      //height: "1.69125rem",
      minHeight: "1.69125rem",
      border: state.isFocused
        ? hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc"
        : hasError
        ? "1px solid red"
        : layout === "dark"
        ? "1px solid #555"
        : "1px solid #ccc", // Ajustement de la bordure selon le mode
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Background du contrôle selon le mode
      boxShadow: "none",
      "&:hover": {
        border: hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc", // Ajustement de la bordure au survol selon le mode
      },
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
  });
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("auth_token_" + api);
  const [souscriptionData, setSoucriptionData] = useState([]);
  //meta title

  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage

  /*************************   Statut *******************************/
  const [statutData, setStatutData] = useState({ data: [] });
  const [selectedStatut, setSelectedStatut] = useState("");
  const handleStatutChange = (e) => {
    setSelectedStatut(e);
  };
  const getStatut = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/souscriptions/statuts_souscriptions`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((mode) => {
          setStatutData(mode);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderStatutOptions = () => {
    return [
      {
        options: statutData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  function formatDateToFrench(inputDate) {
    // Crée un objet Date à partir de la date d'entrée
    const date = new Date(inputDate);

    // Extrayez le jour, le mois et l'année de l'objet Date
    const day = date.getDate();
    const month = date.getMonth() + 1; // Les mois sont indexés à partir de zéro, donc ajoutez 1
    const year = date.getFullYear();

    // Formate la date en format français (DD/MM/YYYY)
    const formattedDate = `${day.toString().padStart(2, "0")}/${month
      .toString()
      .padStart(2, "0")}/${year}`;

    return formattedDate;
  }

  const getData = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/souscriptions/${id}/edit`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 403) {
        navigate(`${backUrl}/forbidden`);
      }
      if (response.status === 500) {
        navigate(`${backUrl}/error`);
      }
      if (response.status === 203) {
        navigate(`${backUrl}/error404`);
      }
      if (response.status === 401) {
        localStorage.removeItem("auth_token_" + api);
        localStorage.removeItem("authUser_" + api);
        localStorage.removeItem("sideBar_" + api);
        navigate(`${backUrl}/login`);
        window.location.reload(false);
      }

      const souscriptionData = await response.json();
      setSoucriptionData(souscriptionData);
      setSelectedPartenaire(
        souscriptionData?.detail_souscription?.["Informations générales"]
          ?.Partenaire
      );
      setSelectedInvestisseur(
        souscriptionData?.detail_souscription?.["Informations générales"]?.[
          "Investisseur"
        ]
      );
      setSelectedStatut(
        souscriptionData?.detail_souscription?.["Informations générales"]
          ?.Statut
      );
      setSelectedCategorie(
        souscriptionData?.detail_souscription?.["Informations générales"]?.[
          "Catégorie PME"
        ]
      );
      setSelectedPme(
        souscriptionData?.detail_souscription?.["Détails de la souscription"]
          ?.PME
      );
      setSelectedReservation(
        souscriptionData?.detail_souscription?.["Informations générales"]
          ?.Réservation
      );
      setSelectedTaux(
        souscriptionData?.detail_souscription?.["Détails de la souscription"]?.[
          "Taux d'apport"
        ]
      );
      setSelectedDateSouscription(
        souscriptionData?.detail_souscription?.["Détails de la souscription"]?.[
          "Date de souscription"
        ]
      );
      setSelectedTranche(
        souscriptionData?.detail_souscription?.["Détails de la souscription"]
          ?.Tranche
      );
      setSelectedMtReduction(
        souscriptionData?.detail_souscription?.["Détails de la souscription"]?.[
          "Montant réduction impôt (€)"
        ]
      );
      setSelectedMtReservation(
        souscriptionData?.detail_souscription?.["Détails de la souscription"]?.[
          "Mt. réservation restant (€)"
        ]
      );
      setSelectedMtSouscription(
        souscriptionData?.detail_souscription?.["Détails de la souscription"]?.[
          "Montant souscription (€)"
        ]
      );
      setSelectedNbAction(
        souscriptionData?.detail_souscription?.["Détails de la souscription"]?.[
          "Nb actions souscrites"
        ]
      );
      setSelectedValeurAction(
        souscriptionData?.detail_souscription?.["Détails de la souscription"]?.[
          "Valeur action (€)"
        ]
      );
      setSelectedTauxReduction(
        souscriptionData?.detail_souscription?.[
          "Répartition réduction d'impôt"
        ]?.["Taux de réduction IR"]
      );
      setSelectedTauxReductionA(
        souscriptionData?.detail_souscription?.[
          "Répartition réduction d'impôt"
        ]?.["Taux de réduction ISF"]
      );
      setSelectedNb_actions_ir(
        souscriptionData?.detail_souscription?.[
          "Répartition réduction d'impôt"
        ]?.["Nb actions réduction IR"]
      );
      setSelectedNb_actions_isf(
        souscriptionData?.detail_souscription?.[
          "Répartition réduction d'impôt"
        ]?.["Nb actions réduction ISF"]
      );
    } catch (error) {
      console.error(error);
    }
  };

  /************************* Partenaire *******************************/
  const [partenairesData, setPartenairesData] = useState({ data: [] });
  const [selectedPartenaire, setSelectedPartenaire] = useState("");
  const handlePartenaireChange = (e) => {
    setSelectedPartenaire(e);
  };
  const getPartenaire = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/souscriptions/partenaires`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((mode) => {
          setPartenairesData(mode);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPartenaireOptions = () => {
    return [
      {
        options: partenairesData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   END Partenaire *******************************/
  /*************************   Investisseurs  *******************************/
  const [investisseursData, setInvestisseursData] = useState({ data: [] });
  const [selectedInvestisseur, setSelectedInvestisseur] = useState("");
  const handleInvestisseurChange = (e) => {
    setSelectedInvestisseur(e);
  };
  const getInvestisseurs = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/souscriptions/investisseurs?partenaire_id=${
          selectedPartenaire?.value || ""
        }`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((mode) => {
          setInvestisseursData(mode);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderInvestisseursOptions = () => {
    return [
      {
        options: investisseursData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END Investisseurs *******************************/
  /*************************   Catégorie PME  *******************************/
  const [selectedCategorie, setSelectedCategorie] = useState("");
  const [categorieData, setCategorieData] = useState({ data: [] });
  const handleCategorieChange = (e) => {
    setSelectedCategorie(e);
  };
  const getCategories = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/souscriptions/natures_investissements?id=${id}&natures_investissements=${selectedCategorie?.value}&reservations_id=${selectedReservation?.value}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((categorie) => {
          setCategorieData(categorie);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderCategorieOptions = () => {
    return [
      {
        options: categorieData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   END Catégorie *******************************/
  /*************************   PME  *******************************/
  const [pme, setPmeData] = useState({ data: [] });
  const [selectedPme, setSelectedPme] = useState("");
  const handlePmeChange = (e) => {
    setSelectedPme(e);
  };
  const getPme = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/souscriptions/pmes?id=${id}&natures_investissement_id=${selectedCategorie?.value}&pme_id=${selectedPme?.value}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((pme) => {
          setPmeData(pme);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPmeOptions = () => {
    return [
      {
        options: pme.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END PME *******************************/
  /*************************   Reservation   *******************************/
  const [selectedReservation, setSelectedReservation] = useState("");
  const [reservationData, setReservationData] = useState({ data: [] });
  const handleReservationChange = (e) => {
    setSelectedReservation(e);
  };
  const getReservation = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/souscriptions/reservations?id=${id}&investisseur_id=${selectedInvestisseur?.value}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setReservationData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderReservationOptions = () => {
    return [
      {
        options: reservationData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   END Reservation *******************************/
  /*************************   Taux d'apport  *******************************/
  const [selectedTaux, setSelectedTaux] = useState("");
  const [tauxData, setSelectedTauxData] = useState({ data: [] });
  const handleTauxChange = (e) => {
    setSelectedTaux(e);
  };
  const getTaux = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/souscriptions/taux_apports?id=${id}&reservation_id=${selectedReservation?.value}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((taux) => {
          setSelectedTauxData(taux);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTauxOptions = () => {
    return [
      {
        options: tauxData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /******************************* END Taux d'apport *******************************************/
  /*************************   Taux de reduction  *******************************/
  const [selectedTauxReduction, setSelectedTauxReduction] = useState("");
  const [TauxReductionData, setSelectedTauxReductionData] = useState({
    data: [],
  });
  const handleTauxReductionChange = (e) => {
    setSelectedTauxReduction(e);
  };
  const getTauxReduction = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/souscriptions/taux_reduction_impots`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((taux) => {
          setSelectedTauxReductionData(taux);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTauxReductionOptions = () => {
    return [
      {
        options: TauxReductionData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /******************************* END Taux Reduc *******************************************/
  /*************************   Taux de reduction  *******************************/
  const [selectedTauxReductionA, setSelectedTauxReductionA] = useState("");
  const [TauxReductionAData, setSelectedTauxReductionDataA] = useState({
    data: [],
  });
  const handleTauxReductionAChange = (e) => {
    setSelectedTauxReductionA(e);
  };
  const getTauxReductionA = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/souscriptions/taux_reduction_impots2`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((taux) => {
          setSelectedTauxReductionDataA(taux);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTauxReductionAOptions = () => {
    return [
      {
        options: TauxReductionAData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /******************************* END Taux d'apport *******************************************/
  /*************************   Input *******************************/
  const [selectedMtReduction, setSelectedMtReduction] = useState("");
  const handleMtReductionChange = (e) => {
    setSelectedMtReduction(e.target.value);
  };

  const [selectedNbAction, setSelectedNbAction] = useState("");
  const handleNbActionChange = (e) => {
    setSelectedNbAction(e.target.value);
  };
  const [selectedMtReservation, setSelectedMtReservation] = useState("");
  const handleMtReservationChange = (e) => {
    setSelectedMtReservation(e.target.value);
  };
  const [selectedValeurAction, setSelectedValeurAction] = useState("");
  const handleValeurActionChange = (e) => {
    setSelectedValeurAction(e.target.value);
  };

  const [selectedMtSouscription, setSelectedMtSouscription] = useState("");
  const handleMtSouscriptionChange = (e) => {
    setSelectedMtSouscription(e.target.value);
  };

  const [selectedDateSouscription, setSelectedDateSouscription] = useState("");

  const [selectedNb_actions_ir, setSelectedNb_actions_ir] = useState("");
  const handleNbIrChange = (e) => {
    setSelectedNb_actions_ir(e.target.value);
  };
  const [selectedNb_actions_isf, setSelectedNb_actions_isf] = useState("");
  const handleNbIsfChange = (e) => {
    setSelectedNb_actions_isf(e.target.value);
  };
  /******************************* END Input *******************************************/
  /******************************* Mode de règlement *******************************************/
  const [selectedTranche, setSelectedTranche] = useState("");
  const [trancheData, setTrancheData] = useState({ data: [] });
  const handleTrancheChange = (e) => {
    setSelectedTranche(e);
  };

  const getTranche = async () => {
    try {
      await fetch(
        `https://www.fluxod.com/${api}/souscriptions/tranchs?id=${id}&pme_id=${selectedPme?.value}&tranche_id=${selectedTranche?.value}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((mode) => {
          setTrancheData(mode);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTrancheOptions = () => {
    return [
      {
        options: trancheData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /******************************* END Tranche *******************************************/
  /************************* Nb actions restantes *******************************/
  const [nbActionsRestantes, setNbActionsRestantes] = useState();
  const [forceRender, setForceRender] = useState(false);
  const [forceRender0, setForceRender0] = useState(false);
  const [nbActionsMAx, setNbActionsMax] = useState();
  console.log(nbActionsMAx);
  const [forceRender1, setForceRender1] = useState(false);
  const [forceRender2, setForceRender2] = useState(false);
  const [forceRender3, setForceRender3] = useState(false);
  const [forceRender4, setForceRender4] = useState(false);

  const getValue = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/souscriptions/update_values?nb_actions_souscrites=${selectedNbAction}&statuts_souscription_id=${
          selectedStatut?.value || ""
        }&tranch_id=${selectedTranche?.value || ""}&natures_investissement=${
          selectedCategorie?.value || ""
        }&pme_id=${selectedPme?.value || ""}&reservation_id=${
          selectedReservation?.value || ""
        }&taux_apport_id=${selectedTaux?.value || ""}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          console.log(data);
          setNbActionsRestantes(data?.restant_a_souscrire);
          setSelectedMtSouscription(data?.montant_souscription);
          setSelectedValeurAction(data?.valeur_action);
          setSelectedMtReservation(data?.montant_reservation_restant);
          setSelectedMtReduction(data?.montant_reduction_impot);
          setForceRender(!forceRender);
          setForceRender0(!forceRender0);

          setForceRender1(!forceRender1);
          setForceRender2(!forceRender2);
          setForceRender3(!forceRender3);
        });
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getValue();
    getTranche();
  }, [
    selectedTaux,
    selectedTranche,
    selectedCategorie,
    selectedStatut,
    selectedNbAction,
    selectedPme,
    selectedReservation,
  ]);
  /******************************* Submit Edit *******************************************/
  useEffect(() => {
    setNbActionsMax(Math.floor(selectedMtReservation / selectedValeurAction));
  }, [selectedMtReservation, selectedValeurAction]);

  const handleNavigate = () => {
    localStorage.setItem("key", true);
    localStorage.setItem("lastId", id);
    navigate(-1);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (
      selectedPartenaire === null &&
      selectedStatut === null &&
      selectedTaux === null &&
      selectedCategorie === null
    ) {
      toast.error("Remplissez les champs obligatoires");
    } else if (selectedPartenaire === null && selectedStatut === null) {
      toast.error("Le statut et le partenaire ne peuvent pas être vide");
    } else if (selectedTaux === null) {
      toast.error("Le taux ne peut pas être vide");
    } else if (selectedCategorie === null) {
      toast.error("La catégorie ne peut pas être vide");
    } else if (selectedPartenaire === null) {
      toast.error("Le partenaire ne peut pas être vide");
    } else if (selectedStatut === null) {
      toast.error("Le statut ne peut pas être vide");
    } else {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/souscriptions/update`,
          {
            method: "PATCH",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              souscription: {
                id: id,
                investisseur_id: selectedInvestisseur?.value || "",
                pme_id: selectedPme?.value || "",
                tranch_id: selectedTranche?.value || "",
                date_souscription: selectedDateSouscription,
                nombre_actions: selectedNbAction,
                valeur_action: selectedValeurAction,
                montant_souscription: selectedMtSouscription,

                reservation_id: selectedReservation?.value || "",
                natures_investissement_id: selectedCategorie?.value || "",
                statuts_souscription_id: selectedStatut?.value || "",
                partenaire_id: selectedPartenaire?.value || "",
                montant_reduction_impot: selectedMtReduction,

                taux_apport_id: selectedTaux?.value || "",

                nb_actions_ir: selectedNb_actions_ir,
                nb_actions_isf: selectedNb_actions_isf,
                taux_reduction_impot_id: selectedTauxReduction?.value || "",
                taux_reduction_impot2_id: selectedTauxReductionA?.value || "",

                nb_actions_souscrites: selectedNbAction,
              },
            }),
          }
        );

        if (response.ok) {
          console.log("PATCH request successful");
          handleNavigate();
        } else {
          console.error("PATCH request failed");
          const responseData = await response.json();

          if (responseData && responseData.souscription_validation) {
            // Si le champ "contact_validation" est présent dans la réponse JSON
            const errors = responseData?.souscription_validation;

            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };
  /******************************* END Validation *******************************************/
  useEffect(() => {
    const fetchData = async () => {
      try {
        await getData();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    if (!loading) {
      getTranche();
      getPartenaire();
      getStatut();
      getTaux();
      // getReservation();
      // getInvestisseurs();
      getPme();
      getCategories();
      getTauxReduction();
      getTauxReductionA();
    }
  }, [loading]);
  useEffect(() => {
    if (!loading) {
      setSelectedTranche(null);
      setForceRender4(!forceRender4);
    }
  }, [selectedPme]);
  useEffect(() => {
    if (!loading) {
      getInvestisseurs();
    }
  }, [loading, selectedPartenaire]);
  useEffect(() => {
    if (!loading) {
      getReservation();
    }
  }, [loading, selectedInvestisseur]);
  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  document.title = "Souscriptions | Edit";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };

    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            to="#details"
            onClick={() => handleTabClick("details")}
          >
            Détails souscription
          </NavLink>
        </NavItem>
      </Nav>
    );
  };

  return (
    <>
      <React.Fragment>
        <div className="page-content" style={{ fontFamily: "sans-serif" }}>
          <div className="container-fluid">
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody className="border-bottom">
                    <div className="d-flex align-items-center">
                      <h5
                        className="mb-0 card-title flex-grow-1"
                        style={{ fontWeight: "bold", display: "flex" }}
                      >
                        <Link
                          to={`${backUrl}/souscriptions/`}
                          style={{
                            color: "#555B21",
                            textDecoration: "underline !important",
                          }}
                        >
                          Souscriptions
                        </Link>{" "}
                        <i className="bx bx-caret-right"></i>{" "}
                        {!loading ? (
                          souscriptionData.sil
                        ) : (
                          <>
                            <span
                              className="placeholder col-3"
                              style={{ height: "1em" }}
                            ></span>
                          </>
                        )}
                      </h5>
                    </div>

                    <div className="d-flex justify-content-end">
                      <div className="d-flex align-items-end">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={handleSubmit}
                        >
                          <i className="bx bx-send"></i> Valider
                        </button>
                        &nbsp; &nbsp;
                        <Link
                          to="#"
                          onClick={() => navigate(-1)}
                          className="btn btn-sm btn-soft-secondary "
                          style={{ width: "88.43px" }}
                        >
                          <i className="bx bx-arrow-back"></i> Annuler
                        </Link>
                      </div>
                    </div>
                  </CardBody>
                  {CustomNavTabs()}
                  <CardBody>
                    {activeTab === "details" && (
                      <div>
                        {!loading ? (
                          <>
                            <Row>
                              <Col sm="6">
                                <Card className="mb-4">
                                  <CardTitle
                                    tag="h5"
                                    style={{ paddingLeft: "10px" }}
                                  >
                                    Informations générales
                                  </CardTitle>
                                  <CardBody>
                                    {Object?.entries(
                                      souscriptionData?.detail_souscription?.[
                                        "Informations générales"
                                      ]
                                    ).map(([key, value], index) => (
                                      <Row className="mb-2" key={index}>
                                        {key === "Statut" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span>{key}* :</span>
                                              </i>
                                            </Col>
                                            <Col className="col-md-6">
                                              <Select
                                                defaultValue={
                                                  selectedStatut?.label == null
                                                    ? null
                                                    : selectedStatut
                                                }
                                                onChange={handleStatutChange}
                                                options={renderStatutOptions()}
                                                isClearable={true}
                                                className="select2"
                                                styles={styles(
                                                  selectedStatut === null
                                                )}
                                              />
                                              {selectedStatut === null ? (
                                                <div
                                                  style={{
                                                    color: "red",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  Statut ne peut pas être vide
                                                </div>
                                              ) : (
                                                ""
                                              )}
                                            </Col>
                                          </>
                                        ) : key === "Réservation" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span>{key} :</span>
                                              </i>
                                            </Col>
                                            <Col className="col-md-6">
                                              <Select
                                                defaultValue={
                                                  selectedReservation?.label ==
                                                  null
                                                    ? null
                                                    : selectedReservation
                                                }
                                                onChange={
                                                  handleReservationChange
                                                }
                                                options={renderReservationOptions()}
                                                isClearable={true}
                                                className="select2"
                                                styles={styles(false)}
                                              />
                                            </Col>
                                          </>
                                        ) : key === "Catégorie PME" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span>{key}* :</span>
                                              </i>
                                            </Col>
                                            <Col className="col-md-6">
                                              <Select
                                                defaultValue={
                                                  selectedCategorie?.label ==
                                                  null
                                                    ? null
                                                    : selectedCategorie
                                                }
                                                onChange={handleCategorieChange}
                                                options={renderCategorieOptions()}
                                                isClearable={true}
                                                className="select2"
                                                styles={styles(
                                                  selectedCategorie === null
                                                )}
                                              />
                                              {selectedCategorie === null ? (
                                                <div
                                                  style={{
                                                    color: "red",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  Catégorie ne peut pas être
                                                  vide
                                                </div>
                                              ) : (
                                                ""
                                              )}
                                            </Col>
                                          </>
                                        ) : key === "Partenaire" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span>{key}* :</span>
                                              </i>
                                            </Col>
                                            <Col className="col-md-6">
                                              <Select
                                                defaultValue={
                                                  selectedPartenaire?.label ==
                                                  null
                                                    ? null
                                                    : selectedPartenaire
                                                }
                                                onChange={
                                                  handlePartenaireChange
                                                }
                                                options={renderPartenaireOptions()}
                                                isClearable={true}
                                                className="select2"
                                                styles={styles(
                                                  selectedPartenaire === null
                                                )}
                                              />
                                              {selectedPartenaire === null ? (
                                                <div
                                                  style={{
                                                    color: "red",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  Partenaire ne peut pas être
                                                  vide
                                                </div>
                                              ) : (
                                                ""
                                              )}
                                            </Col>
                                          </>
                                        ) : key === "Investisseur" ? (
                                          <>
                                            <Col
                                              xs={12}
                                              md={12}
                                              lg={4}
                                              style={colStyle}
                                            >
                                              <i style={{ color: "#9d9c9c" }}>
                                                <span>{key}* :</span>
                                              </i>
                                            </Col>
                                            <Col className="col-md-6">
                                              <Select
                                                defaultValue={
                                                  selectedInvestisseur?.label ==
                                                  null
                                                    ? null
                                                    : selectedInvestisseur
                                                }
                                                onChange={
                                                  handleInvestisseurChange
                                                }
                                                options={renderInvestisseursOptions()}
                                                isClearable={true}
                                                className="select2"
                                                styles={styles(
                                                  selectedInvestisseur === null
                                                )}
                                              />
                                              {selectedInvestisseur === null ? (
                                                <div
                                                  style={{
                                                    color: "red",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  Investisseur ne peut pas être
                                                  vide
                                                </div>
                                              ) : (
                                                ""
                                              )}
                                            </Col>
                                          </>
                                        ) : null}
                                      </Row>
                                    ))}
                                  </CardBody>
                                </Card>
                                <Col sm="12">
                                  <Card className="mb-4">
                                    <CardTitle
                                      tag="h5"
                                      style={{
                                        paddingLeft: "10px",
                                        paddingTop: "10px",
                                      }}
                                    >
                                      Répartition réduction d'impôt
                                    </CardTitle>
                                    <CardBody>
                                      {Object.entries(
                                        souscriptionData?.detail_souscription?.[
                                          "Répartition réduction d'impôt"
                                        ]
                                      ).map(([key, value], index) => (
                                        <Row className="mb-2" key={index}>
                                          {key === "Nb actions réduction IR" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key} :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <input
                                                  className="form-control form-control-sm"
                                                  defaultValue={
                                                    selectedNb_actions_ir
                                                  }
                                                  onChange={handleNbIrChange}
                                                />
                                              </Col>
                                            </>
                                          ) : key ===
                                            "Nb actions réduction ISF" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key} :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <input
                                                  className="form-control form-control-sm"
                                                  defaultValue={
                                                    selectedNb_actions_isf
                                                  }
                                                  onChange={handleNbIsfChange}
                                                />
                                              </Col>
                                            </>
                                          ) : key === "Taux de réduction IR" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key} :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <Select
                                                  defaultValue={
                                                    selectedTauxReduction?.label ==
                                                    null
                                                      ? null
                                                      : selectedTauxReduction
                                                  }
                                                  onChange={
                                                    handleTauxReductionChange
                                                  }
                                                  options={renderTauxReductionOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                />
                                              </Col>
                                            </>
                                          ) : key ===
                                            "Taux de réduction ISF" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key} :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <Select
                                                  defaultValue={
                                                    selectedTauxReductionA?.label ==
                                                    null
                                                      ? null
                                                      : selectedTauxReductionA
                                                  }
                                                  onChange={
                                                    handleTauxReductionAChange
                                                  }
                                                  options={renderTauxReductionAOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                  styles={styles(
                                                    selectedTauxReductionA ===
                                                      null
                                                  )}
                                                />
                                              </Col>
                                            </>
                                          ) : null}
                                        </Row>
                                      ))}
                                    </CardBody>
                                  </Card>
                                </Col>
                              </Col>
                              {/* detail */}
                              <Col sm="6">
                                <Row>
                                  <Card className="mb-4">
                                    <CardTitle tag="h5">
                                      Détails de la souscription
                                    </CardTitle>
                                    <CardBody>
                                      {Object.entries(
                                        souscriptionData?.detail_souscription?.[
                                          "Détails de la souscription"
                                        ]
                                      ).map(([key], index) => (
                                        <Row key={index} className="mb-2">
                                          {key == "Taux d'apport" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key}* :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <Select
                                                  defaultValue={
                                                    selectedTaux?.label == null
                                                      ? null
                                                      : selectedTaux
                                                  }
                                                  onChange={handleTauxChange}
                                                  options={renderTauxOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                  styles={styles(
                                                    selectedTaux === null
                                                  )}
                                                />
                                                {selectedTaux === null ? (
                                                  <div
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    Taux d'apport ne peut pas
                                                    être vide
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </>
                                          ) : key == "PME" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key}* :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <Select
                                                  defaultValue={
                                                    selectedPme?.label == null
                                                      ? null
                                                      : selectedPme
                                                  }
                                                  onChange={handlePmeChange}
                                                  options={renderPmeOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                  styles={styles(
                                                    selectedPme === null
                                                  )}
                                                />
                                                {selectedPme === null ? (
                                                  <div
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    PME ne peut pas être vide
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </>
                                          ) : key == "Tranche" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key}* :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <Select
                                                  key={forceRender4}
                                                  defaultValue={
                                                    selectedTranche?.label ==
                                                    null
                                                      ? null
                                                      : selectedTranche
                                                  }
                                                  onChange={handleTrancheChange}
                                                  options={renderTrancheOptions()}
                                                  isClearable={true}
                                                  className="select2"
                                                  styles={styles(
                                                    selectedTranche === null
                                                  )}
                                                />
                                                {selectedTranche === null ? (
                                                  <div
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                    }}
                                                  >
                                                    Tranche ne peut pas être
                                                    vide
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </>
                                          ) : key == "Nb actions souscrites" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key}* :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <input
                                                  className="form-control form-control-sm"
                                                  defaultValue={
                                                    selectedNbAction
                                                  }
                                                  required
                                                  onChange={
                                                    handleNbActionChange
                                                  }
                                                />
                                              </Col>
                                              {nbActionsMAx &&
                                              nbActionsMAx > 0 ? (
                                                <div
                                                  style={{
                                                    color: "red",
                                                    whiteSpace: "nowrap",
                                                    fontSize: 12,
                                                  }}
                                                >
                                                  Max restant à ajouter :{" "}
                                                  {nbActionsMAx}
                                                </div>
                                              ) : null}
                                              {nbActionsMAx &&
                                              nbActionsMAx < 0 ? (
                                                <div
                                                  style={{
                                                    color: "red",
                                                    whiteSpace: "nowrap",
                                                    fontSize: 12,
                                                  }}
                                                >
                                                  Attention, vous avez dépassé
                                                  le nombre d'actions possible !
                                                </div>
                                              ) : null}
                                              {selectedNbAction === "" ? (
                                                <div
                                                  style={{
                                                    color: "red",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  Nb actions ne peut pas être
                                                  vide
                                                </div>
                                              ) : (
                                                ""
                                              )}
                                            </>
                                          ) : key == "Valeur action (€)" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key} :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <input
                                                  className="form-control form-control-sm"
                                                  defaultValue={
                                                    selectedValeurAction
                                                  }
                                                  disabled
                                                  onChange={
                                                    handleValeurActionChange
                                                  }
                                                  key={forceRender0}
                                                />
                                              </Col>
                                            </>
                                          ) : key ==
                                            "Montant souscription (€)" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key} :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <input
                                                  className="form-control form-control-sm"
                                                  defaultValue={
                                                    selectedMtSouscription
                                                  }
                                                  key={forceRender}
                                                  disabled
                                                  onChange={
                                                    handleMtSouscriptionChange
                                                  }
                                                />
                                              </Col>
                                            </>
                                          ) : key ==
                                            "Mt. réservation restant (€)" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key} :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <input
                                                  className="form-control form-control-sm"
                                                  defaultValue={
                                                    selectedMtReservation
                                                  }
                                                  key={forceRender1}
                                                  disabled
                                                  onChange={
                                                    handleMtReservationChange
                                                  }
                                                />
                                              </Col>
                                            </>
                                          ) : key ==
                                            "Montant réduction impôt (€)" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key} :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <input
                                                  className="form-control form-control-sm"
                                                  defaultValue={
                                                    selectedMtReduction
                                                  }
                                                  key={forceRender2}
                                                  disabled
                                                  onChange={
                                                    handleMtReductionChange
                                                  }
                                                />
                                              </Col>
                                            </>
                                          ) : key == "Date de souscription" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key}* :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <InputMask
                                                  mask="99/99/9999"
                                                  value={
                                                    selectedDateSouscription
                                                  }
                                                  className="form-control form-control-sm input-color"
                                                  onChange={(dateString) => {
                                                    setSelectedDateSouscription(
                                                      dateString.target.value
                                                    );
                                                  }}
                                                />
                                                {selectedDateSouscription ===
                                                "" ? (
                                                  <div
                                                    style={{
                                                      color: "red",
                                                      whiteSpace: "nowrap",
                                                      textAlign: "left",
                                                    }}
                                                  >
                                                    Date de souscription ne peut
                                                    pas être vide
                                                  </div>
                                                ) : (
                                                  ""
                                                )}
                                              </Col>
                                            </>
                                          ) : key == "Nb actions restantes" ? (
                                            <>
                                              <Col
                                                xs={12}
                                                md={12}
                                                lg={4}
                                                style={colStyle}
                                              >
                                                <i style={{ color: "#9d9c9c" }}>
                                                  <span>{key} :</span>
                                                </i>
                                              </Col>
                                              <Col className="col-md-6">
                                                <input
                                                  className="form-control form-control-sm"
                                                  key={forceRender3}
                                                  defaultValue={
                                                    nbActionsRestantes
                                                  }
                                                  disabled
                                                />
                                              </Col>
                                            </>
                                          ) : (
                                            <></>
                                          )}
                                        </Row>
                                      ))}
                                      {/* <Row>
                                        <Col
                                          xs={12}
                                          md={12}
                                          lg={4}
                                          style={colStyle}
                                        >
                                          <i style={{ color: "#9d9c9c" }}>
                                            <span
                                              style={{
                                                display: "inline-block",
                                                width: "8em",
                                                whiteSpace: "nowrap",
                                                paddingTop: "10px",
                                              }}
                                            >
                                              Nb actions restantes:
                                            </span>
                                          </i>
                                        </Col>
                                        <Col
                                          className="col-md-6"
                                          style={{ textAlign: "right" }}
                                        >
                                          <input
                                            className="form-control form-control-sm"
                                            key={forceRender3}
                                            defaultValue={nbActionsRestantes}
                                            disabled
                                          />
                                        </Col>
                                      </Row> */}
                                    </CardBody>
                                  </Card>
                                </Row>
                              </Col>
                              {/* <Col sm="12">
                                <Row>
                                  <Col sm="6">
                                    <Card className="mb-4">
                                      <CardTitle
                                        tag="h5"
                                        style={{ paddingLeft: "10px" }}
                                      >
                                        Répartition réduction d'impôt
                                      </CardTitle>
                                      <CardBody>
                                        {Object.entries(
                                          souscriptionData
                                            ?.detail_souscription?.[
                                            "Répartition réduction d'impôt"
                                          ]
                                        ).map(([key, value], index) => (
                                          <Row className="mb-2" key={index}>
                                            {key ===
                                            "Nb actions réduction IR" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span
                                                      style={{
                                                        display: "inline-block",
                                                        width: "11em",
                                                        paddingTop: "10px",
                                                      }}
                                                    >
                                                      {key} :
                                                    </span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    defaultValue={
                                                      selectedNb_actions_ir
                                                    }
                                                    onChange={handleNbIrChange}
                                                  />
                                                </Col>
                                              </>
                                            ) : key ===
                                              "Nb actions réduction ISF" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span
                                                      style={{
                                                        display: "inline-block",
                                                        width: "11em",
                                                        paddingTop: "10px",
                                                      }}
                                                    >
                                                      {key} :
                                                    </span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <input
                                                    className="form-control form-control-sm"
                                                    defaultValue={
                                                      selectedNb_actions_isf
                                                    }
                                                    onChange={handleNbIsfChange}
                                                  />
                                                </Col>
                                              </>
                                            ) : key ===
                                              "Taux de réduction IR" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span
                                                      style={{
                                                        display: "inline-block",
                                                        width: "11em",
                                                        paddingTop: "10px",
                                                      }}
                                                    >
                                                      {key} :
                                                    </span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <Select
                                                    defaultValue={
                                                      selectedTauxReduction
                                                    }
                                                    onChange={
                                                      handleTauxReductionChange
                                                    }
                                                    options={renderTauxReductionOptions()}
                                                    isClearable={true}
                                                    className="select2"
                                                  />
                                                </Col>
                                              </>
                                            ) : key ===
                                              "Taux de réduction ISF" ? (
                                              <>
                                                <Col
                                                  xs={12}
                                                  md={12}
                                                  lg={4}
                                                  style={colStyle}
                                                >
                                                  <i
                                                    style={{ color: "#9d9c9c" }}
                                                  >
                                                    <span
                                                      style={{
                                                        display: "inline-block",
                                                        width: "11em",
                                                        paddingTop: "10px",
                                                      }}
                                                    >
                                                      {key} :
                                                    </span>
                                                  </i>
                                                </Col>
                                                <Col className="col-md-6">
                                                  <Select
                                                    defaultValue={
                                                      selectedTauxReductionA
                                                    }
                                                    onChange={
                                                      handleTauxReductionAChange
                                                    }
                                                    options={renderTauxReductionAOptions()}
                                                    isClearable={true}
                                                    className="select2"
                                                  />
                                                </Col>
                                              </>
                                            ) : null}
                                          </Row>
                                        ))}
                                      </CardBody>
                                    </Card>
                                  </Col>
                                </Row>
                              </Col> */}
                            </Row>
                          </>
                        ) : (
                          <Spinners setLoading={setLoading} />
                        )}
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
        <ToastContainer />
      </React.Fragment>
    </>
  );
}

export default EditReservation;
